import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/ui.css";

import {useSigma} from "@react-sigma/core";
import React, {useState} from "react";

import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import Legend from "../Legend";
import HideLabelToggleButton from "../HideLabelToggleButton";
import LegendInfoButton from "../LegendInfoButton";
import {UIBottomLeft, UIBottomRight, UITopLeft, UITopRight} from "../layout/UI";
import ListLinkButton from "../ListLinkButton";
import NodeContextMenu from "../NodeContextMenu";
import ResetGraphButton from "../ResetGraphButton";
import OverlayLinkButton from "../OverlayLinkButton";
import SearchBox from "../SearchBox";
import Screenshot from "../SigmaScreenshot";
import SubNetworkLinkButton from "../SubNetworkLinkButton";
import {TheCellMapZoomControl} from "../TheCellMapZoomControl";
import NodelessPanel from "./NodelessPanel";

const NetworkUserInterface = React.memo(() => {
  const {selectedGenes} = useTheCellMapContext();
  const sigma = useSigma();
  const [showLegend, setShowLegend] = useState(false);

  return <>
    <UITopLeft>
      <ResetGraphButton/>
      <SearchBox/>
      <ListLinkButton/>

      {selectedGenes.length > 0 && (
        <SubNetworkLinkButton/>
      )}
    </UITopLeft>

    <UIBottomLeft direction="row" align="end">
      <div className="d-flex flex-column-reverse gap-2">
        <TheCellMapZoomControl/>
        <HideLabelToggleButton/>
        <LegendInfoButton showLegend={showLegend} onToggle={() => setShowLegend(v => !v)}/>
        <Screenshot fileName="thecellmap_human_network" sigma={sigma} showLegend={showLegend}/>
      </div>
      {showLegend && <Legend/>}
    </UIBottomLeft>

    <UITopRight>
      <OverlayLinkButton/>
    </UITopRight>

    <UIBottomRight containerClassName="message-panel-container">
      <NodelessPanel/>
    </UIBottomRight>

    <NodeContextMenu/>
  </>
});

export default NetworkUserInterface;
